<template>
	<div>
		<div
			v-if="$auth.user"
			class="first-step-form-information"
		>
			<div
				v-if="title"
				class="d-flex align-items-start justify-content-center justify-content-lg-start"
			>
				<img src="/icons-front/magic-autocomplete.png" alt="edit-form" class="mr-2">
				<span>{{ title }}</span>
			</div>
			<div class="d-flex flex-lg-column justify-content-center align-items-center">
				<span class="strong mb-lg-2">{{ submitDescription }}</span>
				<b-button
					variant="primary"
					class="d-none d-lg-block"
					@click="submit"
				>
					{{ submitTitle }}
				</b-button>
				<b-button
					variant="link"
					class="d-lg-none"
					@click="submit"
				>
					{{ submitTitle }}
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
	name: 'FirstStepInformation',
	props: {
		title: {
			type: String,
			default: 'Заполнили форму данными из вашего профиля.',
		},
		submitTitle: {
			type: String,
			default: 'Изменить',
		},
		submitDescription: {
			type: String,
			default: 'Что-то неверно?',
		},
		customSubmit: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		...mapMutations('scenarios/paymentForm', ['setFieldsDisabled']),
		submit() {
			if (this.customSubmit) {
				this.$emit('submit');
				return;
			}
			this.setFieldsDisabled(false);
		},
	},
};
</script>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.first-step-form-information {
    height: 13rem;
	padding: 1rem;
	border: 1px solid $border-color;
	border-radius: 0.5rem;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

	@include media-breakpoint-down(lg) {
		height: auto;
		gap: 1.5rem;
	}
}
</style>
